module.exports = __webpack_public_path__ + "img/求伟芹.f541cad1.jpg";